import { createSelector } from 'reselect'
import { SubmitterUsersState } from 'src/app/ApproverExpenseReports/redux/submitterUsers.reducer'
import { ExpenseReportsFiltersBody } from 'src/components/ExpenseReportsBox/ExpenseReportsBox'
import { userIdOption } from 'src/components/UserDropdown/UserDropdown'
import { PaginationResponse } from 'src/models/pagination.models'
import { RootState } from 'src/redux/createRootReducer'
import { ExpenseReportsFullPaginatedDataState } from 'src/redux/expenseReportsFullPaginatedData.reducer'
import {
  selectExpenseReportsListModelFromState,
  selectSubmitterUsersListModelsFromState,
} from 'src/redux/selectors/data/expenses.selectors'

export const selectExpenseReportsFullPaginatedData = (
  state: RootState,
): ExpenseReportsFullPaginatedDataState =>
  state.app.expenseReports.expensesAllReports.expenseReportsFullPaginatedData

export const selectExpenseReportsPaginationFromState = (
  state: RootState,
): PaginationResponse | undefined =>
  state.app.expenseReports.expensesAllReports.expenseReportsFullPaginatedData
    .pagination

export const selectExpenseReportLoadingFromState = (
  state: RootState,
): boolean =>
  state.app.expenseReports.expensesAllReports.expenseReportsFullPaginatedData
    .loading

export const selectExpenseReportCompleteFromState = (
  state: RootState,
): boolean =>
  state.app.expenseReports.expensesAllReports.expenseReportsFullPaginatedData
    .complete

export const selectisEmptyFromState = (state: RootState): boolean =>
  state.app.expenseReports.expensesAllReports.expenseReportsFullPaginatedData
    .isEmpty

export const selectExpenseReportsBodyFromState = (
  state: RootState,
): ExpenseReportsFiltersBody | undefined =>
  state.app.expenseReports.expensesAllReports.expenseReportsFullPaginatedData
    .selectedDownloadExpenseReports

const selectExpenseReportsId = createSelector(
  [selectExpenseReportsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
export const selectExpenseReportsListModels = createSelector(
  [selectExpenseReportsId, selectExpenseReportsListModelFromState],
  (ids, expenseReports) => ids.map((id) => expenseReports[id]),
)

export const selectSubmitterUsers = (state: RootState): SubmitterUsersState =>
  state.app.expenseReports.submitterUsers

export const selectAllSubmitterUserOptionsFromState = createSelector(
  [selectSubmitterUsersListModelsFromState],
  (users) => Object.keys(users).map((id: string) => userIdOption(users[id])),
)
